import { useState, useEffect } from "react";
import ReactGA from "react-ga";
import { Header } from "./components/Header";
import { Title } from "./components/Title";
import { List } from "./components/List";
import { Range } from "./components/Range";

function App() {
  const [scale, setScale] = useState(10);
  const [animate, setAnimate] = useState(false);
  const TRACKING_ID = 'UA-1577313-14';
  
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID);
    ReactGA.pageview('wingstop-womens-march-madness');
  })

  return (
    <div className="App">
      <Header />
      <Title />
      <div className="contentContainer">
        <Range scale={scale} setScale={setScale} />
        <List scale={scale} animate={animate} setAnimate={setAnimate} />
      </div>
    </div>
  );
}

export default App;
